module.exports = __webpack_public_path__ + "img/Icom.Computer Studies.16fb6142.svg";